@if ({ selectorIsOpened: siteSelectorOpened$ | async }; as ctx) {
<div class="site-wrapper">
  @if (parentBrandOrgSelector) {
  <div class="header-line d-flex align-items-center">
    @if (multiSiteSupport) { @if (sites.length > 0) {
    <button
      (click)="toggleSiteSelector(!ctx.selectorIsOpened, $event)"
      class="btn icon-container p-0 d-flex flex-shrink-0 align-items-center justify-content-center ml-2"
    >
      <fa-icon [icon]="['fas', 'bars']" class="d-flex site--icon"></fa-icon>
    </button>
    } @if (isSelectedSiteNullish$ | async) {
    <button
      i18n="SiteSelector|Choose Brand@@siteSelectorChooseBrand"
      data-e2e="choose-brand-button"
      class="btn p-0 font-weight-bold site-text"
      [class.ml-3]="sites.length === 0"
      (click)="toggleSiteSelector(!ctx.selectorIsOpened, $event)"
    >
      Choose Brand
    </button>
    } @else {
    <a
      (click)="logoClick()"
      class="text-decoration-none brand-logo-link"
      [routerLink]="rootPath$ | async"
    >
      <epc-brand-org-text-or-logo
        [class.ml-1]="!(sites.length === 0)"
        [class.ml-3]="sites.length === 0"
        [site]="currentSiteBasedOnCondition$ | async"
        [selected]="true"
      ></epc-brand-org-text-or-logo>
    </a>
    } } @else {
    <a
      (click)="logoClick()"
      class="text-decoration-none brand-logo-link"
      routerLink="/"
    >
      <epc-brand-org-text-or-logo
        class="ml-3"
        [site]="selectedSite$ | async"
        [selected]="true"
      ></epc-brand-org-text-or-logo>
    </a>
    }
  </div>
  <div
    [@slideFromLeft]="ctx.selectorIsOpened ? 'open' : 'closed'"
    (@slideFromLeft.done)="onAnimationDone($event)"
    class="brand-selector"
    [class.with-bottom-space]="(isSelectedSiteNullish$ | async) === false"
    [class.in-site-selector]="isSelectedSiteNullish$ | async"
    atxClickOutside
    (clickOutside)="siteSelectorOpened$.next(false)"
  >
    <div data-e2e="brand-menu-contant" class="sites d-flex flex-column h-100">
      @for (site of sites; track trackBySiteId($index, site)) { @if (
      site.subSites?.length > 1 && site.subSiteRequired) {
      <div
        [style.height.%]="isMobile ? null : 100 / sites.length"
        [class.site-option]="!isMobile"
      >
        <epc-brand-org-sub-sites
          class="flex-grow-1"
          [site]="site"
          [height]="100 / sites.length"
          [isMobile]="isMobile"
          [selectorIsOpened]="siteSelectorOpeningIsDone"
          (selectedSubSite)="onSelectedSubSiteClick($event, site)"
        ></epc-brand-org-sub-sites>
      </div>
      } @else {
      <div
        [style.height.%]="isMobile ? null : 100 / sites.length"
        class="site-option border-bottom d-flex justify-content-center align-items-center flex-shrink-0 p-0"
      >
        <epc-brand-org-text-or-logo
          class="flex-grow-1"
          [site]="site.subSites?.length === 1 ? site?.subSites?.[0] : site"
          (click)="onSelectSiteClick(site)"
        ></epc-brand-org-text-or-logo>
      </div>
      } }
    </div>
  </div>
  } @else {
  <div
    data-e2e="brand-menu-contant bg-transparent"
    class="sites d-flex flex-column"
  >
    @for (site of sites; track trackBySiteId($index, site)) {
    <div
      data-e2e="site-option"
      [style.height.%]="100 / sites.length"
      class="site-option subsite border-bottom d-flex justify-content-center align-items-center flex-shrink-0 p-0"
      (click)="onSelectSiteClick(site)"
    >
      <epc-brand-org-text-or-logo
        class="flex-grow-1"
        [site]="site"
      ></epc-brand-org-text-or-logo>
    </div>
    }
  </div>
  }
</div>
}
